export const basicCoverageDetailId = 160

export const maritalStatusTableName = "MARITAL_STATUS"
export const relationshipTableName = "LIFE_CLAIMANT_FAMILY_LEFT"
export const lifeClaimantRelationship = "LIFE_CLAIMANT_RELATIONSHIP"

export const sep = "/"
